import {
  emptyString,
  length,
  password
} from './index'
export default (newPassword) => {
  if (!emptyString(newPassword, 'Password', 'Password')) {
    return false
  } if (!length(newPassword, 'Password', 6, undefined, 'Password')) {
    return false
  } if (!password(newPassword, 'Password', 'Password')) {
    return false
  }
  return true
}
